import { Box, Grid, Switch } from '@mui/material';
import { saveJobFieldSettings } from 'wisestep-api';
import { Label } from 'wisestep-base';

import { useWorkspaceContext } from '../../../context';
import { useJobSettingsContext } from '../../../context/jobsListContext';
import {
  getSettingBreadCrumbList,
  ISettingBreadCrumbTypes,
  Pages,
} from '../../../features/teams/helper/defaultValues';
import { AtsCustomAPIAccess, useAtsCustomAPIAccess } from '../../../hooks/useAtsCustomAPIAccess';
import { success, warning } from '../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../utils/NotificationStore';
import JobSettingsLayout from '../components/JobSettingsLayout';

const JobPostingSettings = () => {
  const setNotification = useNotificationStore((state) => state.setNotification);
  const jobFieldSettings = useJobSettingsContext();

  const workspaceContext = useWorkspaceContext();
  const { access: atsCustomAccessControl } = useAtsCustomAPIAccess([
    AtsCustomAPIAccess.MANAGE_JOB_ADMIN_TEAM_AS_MANDATORY,
  ]);

  const manageAccess = workspaceContext.owns || atsCustomAccessControl[0];

  const onChangeHandler = async (checked) => {
    jobFieldSettings.adminTeamSelectionMandatory = checked;
    try {
      await saveJobFieldSettings(jobFieldSettings);
      setNotification(success('Job Post Settings Updated Successfully.'));
    } catch (error) {
      setNotification(warning('Something Went Wrong , Please try again'));
    }
  };
  return (
    <JobSettingsLayout
      title="Job Admin Settings"
      indexLabel="Job Admin Settings"
      indexUrl="/job-posting-settings"
      breadCrumbsList={getSettingBreadCrumbList(
        ISettingBreadCrumbTypes.JOBS,
        Pages['JOB_ADMIN_SETTING']
      )}
    >
      <Box component="form" px={8} pt={2}>
        <Grid container xs={8}>
          <Grid item xs={10} mb={2}>
            <Label sx={{ fontWeight: 'bold' }}>
              Allow job Admin team selection mandatory to create jobs
            </Label>
          </Grid>
          <Grid item xs={2} textAlign="center" display="flex" pt={1.25} justifyContent="center">
            <Switch
              size="medium"
              defaultChecked={jobFieldSettings.adminTeamSelectionMandatory ?? false}
              onChange={(_event, checked) => onChangeHandler(checked)}
              key={Math.random()}
              disabled={!manageAccess}
            />
          </Grid>
        </Grid>
      </Box>
    </JobSettingsLayout>
  );
};
export default JobPostingSettings;
